<template>
<div class="div1">
<h5>简易图书管理</h5>
<p>
  <label>id: <input type="number" min="1" placeholder="请输入序号" v-model.number="id" required> </label>
  <label>图书名称: <input type="text" placeholder="请输入图书名称" v-model="bookname" required> </label>
  <label>出版社: <input type="text" placeholder="请输入出版社" v-model="press" required> </label>
  <label>作者: <input type="text" placeholder="请输入作者" v-model="author" required> </label>
  <button @click="add">添加</button>
  <button @click="update" :disabled="hbId===0" :class="{'btn-disabled': hbId===0}">更新</button><br>
</p>
<p>
  <label>请输入搜索关键字:
    <input type="text" placeholder="请输入搜索关键字" v-model="keyword">
  </label>
  <button @click="search(keyword)">搜索</button>
</p>
<!--elementui参见https://element.eleme.cn-->

<el-table v-if="bookLists.length > 0" :data="search(keyword)" style="width: 100%" stripe border max-height='250'>
  <el-table-column fixed sortable prop="id" label="序号" align='center' width="100px">
  </el-table-column>
  <el-table-column prop="bookname" label="图书名称" align='center'  width="200px">
  </el-table-column>
  <el-table-column prop="press" label="出版社" align='center'  width="200px"
    :filters="presses"
    :filter-method="filterPress">
  </el-table-column>
  <el-table-column prop="author" label="作者"  align='center'  width="200px">
  </el-table-column>
  <el-table-column prop="author" label="时间"  align='center'  width="200px">
    <template v-slot:default="scope">
      {{ scope.row.ptime | dateFormat }}
    </template>
  </el-table-column>
  <el-table-column fixed="right" label="操作" align='center'  width="250px">
    <template slot-scope="scope">
      <el-button @click="editBook(scope.row.id)" type="text" size="small">{{scope.row.operation[0]}}</el-button>
      <el-button @click="deleteBook(scope.row.id)" type="text" size="small">{{scope.row.operation[1]}}</el-button>
    </template>
  </el-table-column>
</el-table>
<h5 v-else>没书了。抓紧时间补库存</h5>
<h5>共{{ bookLists.length }}本书</h5>
</div>
</template>

<script>
export default {
  name: 'Books',
  data () {
    return {
      keyword: '',
      id: '',
      hbId: 0,
      bookname: '',
      press: '',
      author: '',
      bookLists: [
        {
          id: 1,
          bookname: 'Web前端开发技术',
          press: '清华大学出版社',
          author: '储久良',
          ptime: new Date(),
          operation: ['编辑', '删除']
        },
        {
          id: 2,
          bookname: 'Java程序设计',
          press: '电子工业出版社',
          author: '耿祥义',
          ptime: new Date(),
          operation: ['编辑', '删除']
        },
        {
          id: 3,
          bookname: 'JavaScript高级程序设计',
          press: '高等教育出版社',
          author: '张路路',
          ptime: new Date(),
          operation: ['编辑', '删除']
        },
        {
          id: 4,
          bookname: 'Web前端开发技术2',
          press: '清华大学出版社',
          author: '储久良2',
          ptime: new Date(),
          operation: ['编辑', '删除']
        }
      ]
    }
  },
  computed: {
    presses () {
      var ps = []
      for (let i = 0; i < this.bookLists.length; i++) {
        let book = this.bookLists[i]
        if (!ps.includes(book.press)) {
          ps.push(book.press)
        }
      }
      return ps.map(press => ({text: press, value: press}))
    }
  },
  methods: {
    filterPress (value, row) {
      // console.log(value)
      // console.log([...new Set(this.bookLists.map(book => book.press))].map(press => ({text: press, value: press})))
      return row.press === value
    },
    checkInput (update) { // update为true，表示是更新
      // 数据不为空，才能添加和更新
      if (this.id !== '' && this.bookname !== '' && this.press !== '' && this.author !== '') {
        if (update && this.id === this.hbId) { // 若是更新，则id可以是自己
          return true
        }
        if (this.bookLists.findIndex((item) => (item.id === this.id)) !== -1) {
          alert('图书序号重复，请修改！！')
          return false
        } else if (this.id < 1) {
          alert('图书序号需要最小为1')
          return false
        } else {
          return true
        }
      } else {
        alert('图书数据不完整！，请补充！！')
        return false
      }
    },
    add () {
      if (this.checkInput()) {
        this.bookLists.push({
          id: this.id,
          bookname: this.bookname,
          press: this.press,
          author: this.author,
          ptime: new Date(),
          operation: ['编辑', '删除']
        })
        this.hbId = this.id
        this.keyword = ''
        // setTimeout("alert('图书添加成功')", 100)
      }
    },
    search (bname) { // 返回满足条件的图书数组
      var arrBooks = []
      this.bookLists.forEach((item, i) => {
        if (item.bookname.indexOf(bname) !== -1) {
          arrBooks.push(item) // 当 bname="",indexOf(bname)=0,原数组自动push进来。
        }
      })
      return arrBooks
    },
    deleteBook (id) {
      var inx = this.bookLists.findIndex((item) => (item.id === id))
      this.bookLists.splice(inx, 1)
      if (this.hbId === id) {
        this.hbId = 0 // 删除的是自己
      }
    },
    editBook (id) {
      var inx = this.bookLists.findIndex((item) => (item.id === id))
      this.id = this.bookLists[inx].id
      this.bookname = this.bookLists[inx].bookname
      this.press = this.bookLists[inx].press
      this.author = this.bookLists[inx].author
      this.hbId = id
    },
    update () {
      if (this.checkInput(true)) {
        var inx = this.bookLists.findIndex((item) => (item.id === this.hbId))
        this.bookLists[inx].id = this.id
        this.bookLists[inx].bookname = this.bookname
        this.bookLists[inx].press = this.press
        this.bookLists[inx].author = this.author
        this.hbId = this.id
      }
    }
  },
  filters: {
    dateFormat (date) {
      var dy = date.getFullYear()
      var dm = date.getMonth() + 1
      var dd = date.getDate()
      var dh = date.getHours()
      var dms = date.getMinutes()
      var ds = date.getSeconds()
      return `${dy}-${dm}-${dd}  ${dh}:${dms}:${ds}`
    }
  }
}
</script>

<style scoped>
/* index-4-1.css */
/* 定义图层的样式   */
.div1 {margin: 0 auto;width: 950px;border: 1px dashed #55ed89;}

h5 {
  text-align: center;color: #0033CC;padding: 15px;
  background: #AFAFAF;font-size: 28px;
}
/*定义input标记样式 */
input {
  border-radius: 8px;width: 140px;
  height: 35px;border: 1px dashed #008000;
}
/*定义button,超链接标记样式 */
button,
.btn-success {
  border-radius: 8px;width: 70px;height: 35px;
  background: #008000;color: white;
}
.btn-disabled {
  background: grey;
}

</style>



// WEBPACK FOOTER //
// src/pages/Books.vue